import { render } from "./AboutApplication.vue?vue&type=template&id=96314d42"
import script from "./AboutApplication.vue?vue&type=script&lang=js"
export * from "./AboutApplication.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__